// use global jquery which already setup datatables
var $ = window.$;

window.ttu_bootbox_handle_ajax_error = function(xhr) {
  // 401 from ApplicationController#respond_logged_out / #handle_stale_session_token: the
  // session is gone (timeout, or the browser restarted while this tab kept its old CSRF
  // token). If the server re-authenticated us from the remember-me cookie it sends a fresh
  // token: put it in the meta tag and re-send the same request once, silently (`this` is the
  // jQuery ajax settings object when this helper is passed directly as `error:`). Otherwise
  // go to the login page — the F5 the user would have pressed. (AppSignal #21 cluster)
  if (xhr && xhr.status === 401) {
    var auth = null;
    try { auth = JSON.parse(xhr.responseText); } catch(e) {}
    if (auth && auth.retry && auth.csrf_token) {
      $('meta[name="csrf-token"]').attr('content', auth.csrf_token);
      if (this && this.url && !this._ttu_retried) {
        this._ttu_retried = true;
        return $.ajax(this);
      }
      window.location.reload();
      return;
    }
    if (auth && auth.reload) {
      window.location.assign(auth.url || '/login');
      return;
    }
  }
  var errorMsg = 'เนื่องจาก เกิดข้อผิดพลาดขึ้นในระบบ';
  var statusCode = '-';
  var callback = function(){};
  if (typeof xhr === 'string') {
    errorMsg = xhr;
  } else {
    statusCode = xhr.status;
    try {
      var json = JSON.parse(xhr.responseText);
      if (json.error) {
        errorMsg = 'เกิดข้อผิดพลาด ' + json.error;
      } else if (json.errors && json.errors.constructor === Array) {
        errorMsg = '<p>เกิดข้อผิดพลาด ดังนี้</p> <ul><li>' + json.errors.join('</li><li>') + '</li></ul>';
      }
      // redirect after alert if url is available
      if (json.url) {
        callback = function() {
          window.location.assign(json.url);
        };
      }
    } catch(e) {

    }
  }
  bootbox.alert({
    title: 'ขออภัย ไม่สามารถทำรายการนี้ได้ [' + statusCode + ']',
    message: errorMsg,
    locale: 'th',
    callback: callback,
  });
};

window.ttu_show_bootbox_confirm_delete = (label, remove_url = null, ajax_success_callback = null, option = null) => {
  var default_option = {
    title: 'ยืนยันการลบ',
    message: 'ต้องการลบ ['+label+'] หรือไม่?',
    locale: 'th',
  };

  if (remove_url) {
    var default_ajax_option = {
      url: remove_url,
      method: 'DELETE',
      dataType: 'json',
      beforeSend: (request) => {
        request.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      error: ttu_bootbox_handle_ajax_error,
    };

    if (ajax_success_callback && typeof ajax_success_callback === 'function') {
      default_ajax_option.success = ajax_success_callback;
    }

    default_option.callback = (result) => {
      if (result) {
        $.ajax(default_ajax_option);
      }
    };
  }

  if (option === null) {
    // nothing to do here...
  } else if (typeof option === 'function') {
    // apply option function
    default_option = option(default_option);
  } else if (typeof option === 'object') {
    // TODO: do more elaborate merge?
    Object.assign(default_option, option);
  }

  bootbox.confirm(default_option);
};
